<template>
  <b-form-group>
    <datepicker
        id="date_param"
        :clearable="false"
        :editable="true"
        class="full-width"
        input-class="form-control"
        type="date"
        format="MM/DD/YYYY"
        lang="en"
        v-model="internalValue"
        @change="$emit('valueChanged', internalValue)"
    />
  </b-form-group>
</template>

<script>
import Datepicker from 'vue2-datepicker';

export default {
  props: {
    value:          0,
    modeRestricted: {
      type:    Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: 0
    }
  },
  async created() {
    this.internalValue = this.value;
  },
  methods:    {},
  components: {
    Datepicker
  }
}
</script>

<style>
.full-width {
  width: 100%;
}
</style>
